import { CountryCode, getRequiredFields } from './types'

// we only require the state field for US and CA addresses for now
const stateRequiredCountries: CountryCode[] = ['US', 'CA']

export const isStateFieldRequired = (country: CountryCode) => {
    if (!stateRequiredCountries.includes(country)) {
        return false
    }

    const requiredFields = getRequiredFields(country)
    return requiredFields && requiredFields.includes('state')
}
